export default __webpack_public_path__ + "static/media/mapFrameExplorerCY.8d693fb7.jpg";